<template>
  <div class="popup-wrap" v-if="store.legalNoticePopupName !== null">
    <div class="popup-overlay"></div>
    <div class="popup-container">
      <div class="popup-inner">
        <div
          class="popup-close"
          v-if="store.legalNoticePopupName !== 'CampaignPermission'"
          @click="store.setLegalNoticePopupName(store.targetPopupName)"
        >
          <i class="fas fa-times"></i>
        </div>

        <div v-if="store.legalNoticePopupName == 'GizlilikSozlesmesi'">
          <h1>
            AXA Sigorta Anonim Şirketi Gizlilik Politikası ve Aydınlatma Metni
          </h1>
          <div class="static-text">
            <p>
              <strong>Giriş</strong>
            </p>
            <p>
              AXA Sigorta Anonim Şirketi olarak (“<strong>AXA Sigorta</strong>”,
              “<strong>Şirket</strong>” ya da “<strong>Biz</strong>” olarak
              anılacaktır), Veri Sorumlusu sıfatıyla, sunduğumuz hizmetleri
              yerine getirirken kişisel verilerinizin gizliliğini sağlamaya ve
              verilerinizi mevzuata uygun şekilde işlemeye en yüksek mertebede
              özen göstermekteyiz.
            </p>
            <p>
              Bu kapsamda, 6698 sayılı Kişisel Verilerin Korunması Kanunu’na
              (“<strong>Kanun</strong>” ya da “<strong>KVKK</strong>” olarak
              anılacaktır) uygun olarak hazırlanmış işbu Gizlilik Politikası ve
              Aydınlatma Metni, verinizin asıl sahibi olarak Size bilgi vermek
              ve haklarınızı hatırlatmak amacıyla sunulmaktadır. Kişisel/Özel
              Nitelikli Kişisel Verilerinizin Şirketimize aktarılmasından önce
              lütfen okuyunuz.
            </p>
            <p>
              Bu aydınlatma metninde açıklandığı şekilde kişisel verileriniz ve
              özel nitelikli kişisel verileriniz İlgili mevzuat kapsamında
              kaydedebilecek, arşivlenebilecek, güncellenebilecek,
              aktarılabilecek, sınıflandırılabilecek, KVKK ve ilgili mevzuatta
              sayılan şekillerde işlenebilecektir.
            </p>
            <h3>Kişisel Verilerin Korunması Kanunu Hakkında Bilgilendirme</h3>
            <p>
              Kişisel verilerin işlenmesinde başta özel hayatın gizliliği olmak
              üzere kişilerin temel hak ve özgürlüklerini korumak ve kişisel
              verileri işleyen gerçek ve tüzel kişilerin yükümlülükleri ile
              uyacakları usul ve esasları düzenleyen Kanun hakkında sizleri
              bilgilendirmek istiyoruz.
            </p>
            <h3>Kanun’da Yer Alan Bazı Terimler</h3>
            <p>
              İşbu Aydınlatma Metni’nde kullanılan kişisel veri, özel nitelikli
              kişisel veri, veri işleme ve veri sorumlusu kavramları KVKK’da
              yapılan tanımlara istinaden kullanılmış olup, işbu tanımlar
              aşağıdaki gibi ifade edilmektedir;
            </p>
            <ul>
              <li>
                <strong>Kişisel veri:</strong> Kimliği belirli veya
                belirlenebilir gerçek kişiye ilişkin her türlü bilgi
              </li>
              <li>
                <strong>Özel nitelikli kişisel veri:</strong> Kişilerin ırkı,
                etnik kökeni, siyasi düşüncesi, felsefi inancı, dini, mezhebi
                veya diğer inançları, kılık ve kıyafeti, dernek, vakıf ya da
                sendika üyeliği, sağlığı, cinsel hayatı, ceza mahkumiyeti ve
                güvenlik tedbirleriyle ilgili verileri ile biyometrik ve genetik
                veriler
              </li>
              <li>
                <strong>Veri sorumlusu:</strong> Kişisel verilerin işleme
                amaçlarını ve vasıtalarını belirleyen, veri kayıt sisteminin
                kurulmasından ve yönetilmesinden sorumlu olan gerçek veya tüzel
                kişi
                <div style="padding-left: 15px">
                  <strong>Unvan:</strong> AXA Sigorta Anonim Şirketi
                  <br />
                  <strong>Adres:</strong> Meclisi Mebusan Cad. No:15 34433
                  Salıpazarı, Beyoğlu, İstanbul, TÜRKİYE
                  <br />
                  <strong>Ticaret Sicil No:</strong> 98645
                  <br />
                  <strong>Müşteri Hizmetleri:</strong> (0850) 250 99 99
                  <br />
                  <strong>İnternet Adresi:</strong>
                  <a href="https://www.axasigorta.com.tr/" target="_blank"
                    >www.axasigorta.com.tr</a
                  >
                  <br />
                  <strong>E-posta Adresi:</strong>
                  <a href="mailto:kisiselverikoruma@axasigorta.com.tr"
                    >kisiselverikoruma@axasigorta.com.tr</a
                  >
                </div>
              </li>
              <li>
                <strong>Veri işleyen:</strong> Veri sorumlusunun verdiği yetkiye
                dayanarak onun adına kişisel verileri işleyen gerçek veya tüzel
                kişi
              </li>
              <li>
                <strong>İlgili kişi:</strong> Kişisel verisi işlenen gerçek kişi
              </li>
              <li>
                <strong>Kişisel verilerin işlenmesi:</strong> Kişisel verilerin
                tamamen veya kısmen otomatik olan ya da herhangi bir veri kayıt
                sisteminin parçası olmak kaydıyla otomatik olmayan yollarla elde
                edilmesi, kaydedilmesi, depolanması, muhafaza edilmesi,
                değiştirilmesi, yeniden düzenlenmesi, açıklanması, aktarılması,
                devralınması, elde edilebilir hâle getirilmesi,
                sınıflandırılması ya da kullanılmasının engellenmesi gibi
                veriler üzerinde gerçekleştirilen her türlü işlem
              </li>
              <li>
                <strong>Açık rıza:</strong> Belirli bir konuya ilişkin,
                bilgilendirilmeye dayanan ve özgür iradeyle açıklanan rıza
              </li>
            </ul>
            <p>
              Aydınlatma Bildirimi; “Veri Sorumlusu” veya yetkilendirdiği Gerçek
              / Tüzel Kişi tarafından sözlü, yazılı, çağrı merkezi gibi fiziki
              veya elektronik ortam kullanılmak suretiyle yerine getirilebilir.
              AXA Sigorta olarak bu metin ile aydınlatma yükümlülüğümüzü yerine
              getirmekteyiz. Veri sorumlusu olarak, tarafınızca paylaşılan her
              türlü kişisel veriyi ilgili mevzuata uygun davranarak ve kişisel
              verilerinize uygun güvenlik düzeyini temin etmeye yönelik gerekli
              her türlü teknik ve idari tedbiri alarak muhafaza etmekteyiz.
              (0850) 250 99 99 numaralı Müşteri Hizmetleri Merkezimizi arayarak
              yetkililerimizden daha fazla bilgi alabilirsiniz.
            </p>
            <h2 class="blue-txt">
              A- Tarafımızca Hangi Kişisel Verileriniz İşlenmektedir?
            </h2>
            <p>
              Şirketimizden alacağınız ürün ve hizmetlerin niteliğine bağlı
              olarak kuracağımız ilişki kapsamında; Şirket ile ilgili kişi
              arasındaki ilişkinin türü, niteliği, geçmişi, verinin temin edilme
              yöntemi ve aşağıdaki amaçlara bağlı olarak farklılık gösteren ve
              Kanun’daki ve Şirketimizin Kişisel Verilerin İşlenmesi ve
              Korunması Politikasındaki ilkelere uyumlu bir şekilde işlenen
              kişisel veriler bunlarla sınırlı olmamak üzere, genel olarak
              aşağıdaki gibidir:
            </p>
            <ul>
              <li>
                <strong>Kimlik Bilgileri:</strong> İsim, soy isim, T.C. kimlik
                numarası, pasaport numarası, doğum yeri, doğum tarihi, cinsiyet,
                medeni durum, eş/çocuk bilgisi, vatandaşlık durumu, uyruk
                bilgisi,
              </li>
              <li><strong>Görsel kayıtlar:</strong> Fotoğraf</li>
              <li>
                <strong>İletişim Bilgileri:</strong> Adres, elektronik posta,
                kayıtlı elektronik posta adresi, cep telefonu, sabit telefon ve
                faks numarası gibi iletişim bilgileri ile birlikte, telefon
                görüşmeleri, video görüşmeleri ve elektronik posta yazışmaları
                kapsamındaki iletişim kayıtları diğer sesli ve görüntülü
                veriler,
              </li>
              <li>
                <strong>Online Hizmet Verileri:</strong> Elektronik sigortacılık
                kanallarına giriş için gerekli müşteri bilgileri, IP adresleri,
                şifre ve parolalar, bu kanallarda kullanılan güvenlik
                uygulamaları ve yasal yükümlülüklerin yerine getirilmesi gibi
                amaçlarla işlenen konum bilgileri ile ilgili kişilerin rızasına
                istinaden işlenen biyometrik veriler, Müşterilerimizin, müşteri
                adaylarımızın ve ilgili olabilecek diğer gerçek kişilerin
                verecekleri izin doğrultusunda alışveriş geçmişi bilgileri,
                anket, çerez kayıtları, kampanya çalışmasıyla elde edilen
                veriler,
              </li>
              <li>
                <strong>Ticari Hayata İlişkin Veriler:</strong> Vergi levhası,
                ticaret gazetesi, yetki belgesi, ticaret sicil belgeleri,
                yeterlilik belgeleri, imza sirküleri ve faaliyet belgesi gibi
                tüzel kişilere yönelik belgelerdeki gerçek kişilere ait
                bilgiler, vergi mükellefiyeti durumu kişiye ilişkin bilgiler
                gibi veri sahibini tanıtıcı çeşitli demografik bilgiler,
              </li>
              <li>
                <strong>Sigortacılık ve Finans Verileri:</strong> Şirketimizce
                üretilen fiyatlandırma, müşteri bilgileri, müşterinin
                Şirketimizden aldığı ürün ve hizmetlere yönelik yeknesak
                numaralar, kredi referans numaraları, kredi kartı numaraları,
                hesap numaraları, IBAN, tahsilat ve ödeme faaliyetlerine ilişkin
                detaylı ve her türlü finansal veriler,
              </li>
              <li>
                <strong
                  >Eğitim, İş ve Profesyonel Yaşama İlişkin
                  Bilgileriniz:</strong
                >
                Meslek, unvan, çalışma bilgisi, eğitim durumu, özgeçmiş bilgisi
              </li>
              <li>
                <strong>Hukuki Bilgiler:</strong> Şirketimizin taraf olduğu
                hukuki uyuşmazlıklar nedeniyle edindiği adli makamlarla
                yazışmalardaki bilgiler, dava dosyasındaki bilgiler, alternatif
                uyuşmazlık çözümleri kapsamında tutulan bilgiler gibi veriler,
                Şirketimize tebliğ edilen her türlü idari ve adli makamlara ait
                yazılar içerisindeki veriler,
              </li>
              <li>
                <strong>Kamera ve Giriş – Çıkış Kayıtları:</strong> Şirketimize
                ve bağlı ortaklıklarımıza ait mekanlarda fiziki güvenliğin
                sağlanması amacıyla çalışanlara ve ziyaretlere ait giriş çıkış
                kayıtları ve kamera görüntüleri gibi veriler,
              </li>
              <li>
                <strong>Sağlık Verileri:</strong> Şirketimizle aranızda bulunan
                sigorta sözleşmesi ilişkisi kapsamında ilgili ürün gerektiriyor
                ise, işbu Aydınlatma Metni’nin “D- Kişisel Veri İşleme Amaçları
                ve Hukuki Sebepleri” başlığı altında detayları açıklanan şekilde
                olmak üzere sağlık verileriniz,
              </li>
            </ul>
            <h2 class="blue-txt">
              B- Kişisel Verileriniz Hangi Amaçla İşlenmektedir?
            </h2>
            <p>
              Kişisel/Özel Nitelikli Kişisel Verileriniz, sigortacılık mevzuatı
              ve Türk Ticaret Kanunu kapsamında vermekte olduğumuz risk
              değerlendirmesi, çapraz satış aktiviteleri de dahil olmak üzere
              satış, istatistik, fiyatlama, müşteri memnuniyetine yönelik
              operasyonların planlanması ve icrası, tanıtım, reklam ve pazarlama
              faaliyetleri, hasar ödeme ve asistans faaliyetleri başta olmak
              üzere acentelerimiz ve diğer iş ortaklarımız aracılığıyla sigorta
              sözleşmeleri kapsamında sizlere verilecek hizmetlerin yerine
              getirilmesi süreçlerinde işlenmektedir.
            </p>
            <h2 class="blue-txt">C- Kişisel Verileriniz Toplama Yöntemi</h2>
            <p>
              Sigorta poliçeleri ve emeklilik sözleşmelerinin taraflarına ait
              kişisel/özel nitelikli kişisel veriler; acentelerimiz, internet
              uygulamalarımız ve çağrı merkezimiz aracılığı ile doğrudan doğruya
              sizlerden ve sigorta sözleşmelerinden kaynaklanan yükümlülüklerin
              yerine getirilebilmesi için kamu kurumları tarafından tarafımıza
              erişim yetkisi verilen veri tabanlarından derlenmektedir.
            </p>
            <p>
              Kişisel Verileriniz, Kanun ve sair mevzuat çerçevesinde sadece
              sigortacılık faaliyetlerinin yürütülmesi amacı ile ve bu amacın
              gerektirdiği yasal sürelerle sınırlı olarak işlenmektedir. Kişisel
              / Özel Nitelikli Kişisel Veriler yasal bir zorunluluk ya da işbu
              sözleşme ile vermiş olduğunuz açık rızanız dışında herhangi bir
              üçüncü şahıs, kurum ve kuruluş ile paylaşılmamaktadır. Verileriniz
              hiçbir suretle satılmamaktadır. Bu bilgiler aşağıda belirtilen iki
              şekilde temin edilmektedir.
            </p>
            <h3>a. Sizin Tarafınızdan Sağlanan Bilgiler</h3>
            <p>
              Sizin web sitesi, çevrimiçi uygulamalar, acentelerimiz ve/veya
              çağrı merkezlerimiz vasıtasıyla veya e-posta, faks gibi diğer
              yollarla bize sağladığınız bilgiler, tarafımızdan alınmakta ve
              kaydedilmektedir. Bu yolla elde edilen bilgiler tamamen açık
              rızanızla tarafımıza sağladığınız bilgilerdir. Verdiğiniz
              bilgilerin doğru ve eksiksiz olması sizin sorumluluğunuzdadır.
              Yanlış, yanıltıcı veya eksik bilgi vermeyiniz. Yanlış, yanıltıcı
              veya eksik bilgi verilmesi veya beyanlarda bulunulması, talep
              ettiğiniz sigortanın geçerliliğini, Şirketimizin size karşı olan
              sorumluluklarını ve poliçeye dayalı sigorta tazminatı talep
              haklarını etkileyebilir. Böyle bir durumda Şirketimiz hiçbir
              sorumluluk kabul etmez. Yanlış, yanıltıcı veya eksik bilgi
              vermeniz nedeniyle Şirketimiz bir zarara uğradığı takdirde bu
              zararı tazmin yükümlülüğü tarafınıza aittir. Şirketimize
              sağladığınız bilgilerinizi gözden geçirme ve güncelleme olanağına
              sahipsiniz.
            </p>
            <h3>b. Diğer Kaynaklardan Sağlanan Bilgiler</h3>
            <p>
              Sigorta poliçelerinizin zamanında yenilenmesi ve iletişim
              bilgilerinizin güncel tutulabilmesi için kamu kurumları tarafından
              yasal düzenlemelerle kullanımımıza sunulan veri kaynaklarından
              elde edilen bilgilerdir. Şirketimiz size diğer kaynaklar
              tarafından sağlanan bilgilerinizi gözden geçirme ve güncelleme
              olanağı verir.
            </p>
            <h2 class="blue-txt">
              D- Kişisel Veri İşleme Amaçları ve Hukuki Sebepleri
            </h2>
            <p>
              Şirketimiz tarafından elde edilen kişisel verileriniz, öncelikle
              size güvenli, etkin ve kaliteli hizmet sunulması olmak üzere
              aşağıdaki amaçlarla ve hukuki sebeplerle işlenmektedir:
            </p>
            <table>
              <tr>
                <th>İşleme Amaçlarımız</th>
                <th>Hukuki Sebepler</th>
              </tr>
              <tr valign="top">
                <td>
                  &bull; Müşterinin tanınması, kimlik tespit ve teyit
                  işlemlerinin yapılabilmesi,
                </td>
                <td>
                  &bull; Şirketin hukuki yükümlülüğünü yerine getirebilmesi için
                  zorunlu olması,
                  <br />
                  &bull; Kanunlarda açıkça öngörülmesi
                  <br />
                  &bull; Bir hakkın tesisi, kullanılması veya korunması için
                  veri işlemenin zorunlu olması
                  <br />
                  &bull; Açık rızanın varlığı halinde
                </td>
              </tr>
              <tr valign="top">
                <td>
                  &bull; Sigortacılık ve finans ürünlerinin sunulması, bunlara
                  ilişkin işlemlerin yerine getirilmesi, yürütülmesi,
                  geliştirilmesi, operasyonel süreçlerinin yürütülmesi, iç
                  sistemlere, risk izleme ve bilgilendirme yükümlülüklerine
                  uyulması,
                </td>
                <td>
                  &bull; Bir sözleşmenin kurulması veya ifasıyla doğrudan
                  doğruya ilgili olması kaydıyla, sözleşmenin taraflarına ait
                  kişisel verilerin işlenmesinin gerekli olması
                  <br />
                  &bull; İlgili kişinin temel hak ve özgürlüklerine zarar
                  vermemek kaydıyla, Şirketin meşru menfaatleri için veri
                  işlenmesinin zorunlu olması
                </td>
              </tr>
              <tr valign="top">
                <td>
                  &bull; Hasar ödeme ve asistans faaliyetlerinin yerine
                  getirilmesi,
                </td>
                <td>
                  &bull; Şirketin hukuki yükümlülüğünü yerine getirebilmesi için
                  zorunlu olması,
                  <br />
                  &bull; Bir hakkın tesisi, kullanılması veya korunması için
                  veri işlemenin zorunlu olması
                  <br />
                  &bull; Bir sözleşmenin kurulması veya ifasıyla doğrudan
                  doğruya ilgili olması kaydıyla, sözleşmenin taraflarına ait
                  kişisel verilerin işlenmesinin gerekli olması
                  <br />
                  &bull; İlgili kişinin temel hak ve özgürlüklerine zarar
                  vermemek kaydıyla, Şirketin meşru menfaatleri için veri
                  işlenmesinin zorunlu olması
                </td>
              </tr>
              <tr valign="top">
                <td>
                  &bull; Pazarlama ve satış faaliyetlerinin gerçekleştirilmesi,
                </td>
                <td>
                  &bull; Bir sözleşmenin kurulması veya ifasıyla doğrudan
                  doğruya ilgili olması kaydıyla, sözleşmenin taraflarına ait
                  kişisel verilerin işlenmesinin gerekli olması
                  <br />
                  &bull; İlgili kişinin temel hak ve özgürlüklerine zarar
                  vermemek kaydıyla, Şirketin meşru menfaatleri için veri
                  işlenmesinin zorunlu olması
                </td>
              </tr>
            </table>
            <p>
              Kişisel verileriniz, her türlü sözlü, yazılı, görsel ve elektronik
              ortamda, yukarıda yer verilen amaçlar ve sigortacılık
              hizmetlerinin belirlenen yasal çerçevede verilebilmesi ve bu
              kapsamda AXA Sigorta’nın akdi ve kanuni yükümlülüklerini tam ve
              gereği gibi ifa edebilmesi için elde edilir. Kişiler verilerinizin
              toplanmasının hukuki sebebi KVKK ve sair yasal mevzuat
              hükümleridir. AXA Sigorta tarafından kişisel verileriniz KVKK’nın
              5/1. maddesi uyarınca açık rızanız olması halinde veya KVKK’nın
              5/2. maddesi uyarınca hukuki sebeplere dayanılarak otomatik ve
              otomatik olmayan yöntemlerle işlenmektedir.
            </p>
            <p>
              KVKK’nın 6/1. maddesi uyarınca özel nitelikli kişisel veriler açık
              rızanın olması halinde işlenebilmektedir. AXA Sigorta tarafından
              özel nitelikli kişisel verileriniz açık rızanız alınmak suretiyle
              işlenebilecektir. KVKK’nın 6/3. maddesi uyarınca ise, sağlık ve
              cinsel hayata ilişkin kişisel veriler, kamu sağlığının korunması,
              koruyucu hekimlik, tıbbı teşhis, tedavi ve bakım hizmetlerinin
              yürütülmesi, sağlık hizmetleri ile finansmanının planlanması ve
              yönetimi amacıyla, sır saklama yükümlülüğü altında bulunan kişiler
              veya yetkili kurum ve kuruluşlar tarafından ilgilinin açık rızası
              aranmaksızın işlenebilmektedir. Bu kapsamda, KVKK’nın 6/3. maddesi
              uyarınca, sağlık ve cinsel hayat dışındaki kişisel veriler,
              kanunlarda öngörülen hâllerde ilgili kişinin açık rızası
              aranmaksızın işlenebilir. AXA Sigorta tarafından sağlık ve cinsel
              hayat dışındaki kişisel verileriniz, kanunlarda öngörülen hâllerde
              işlenebilir.
            </p>
            <p>
              Ayrıca, KVKK’nın 6/3. maddesi uyarınca sağlık ve cinsel hayat
              kişisel sağlık verileriniz, kamu sağlığının korunması, koruyucu
              hekimlik, tıbbi teşhis, tedavi ve bakım hizmetlerinin yürütülmesi,
              sağlık hizmetleri ile finansmanının planlanması ve yönetimi
              amaçlarıyla işlenebilmektedir.
            </p>
            <h2 class="blue-txt">
              E- Kişisel Verilerinizi Kimlere ve Hangi Amaçla Aktarıyoruz?
            </h2>
            <p>
              Belirtmek isteriz ki, AXA Sigorta olarak kişisel verilerinizi
              hiçbir zaman yetkisiz üçüncü kişilerle kendi menfaatlerimize
              olacak bir şekilde paylaşmıyor veya erişime açmıyoruz. Mevzuatın
              zorunlu kıldığı ve sizler tarafından izin verilen durumlarda KVKK
              ve ilgili sair mevzuat uyarınca uygun güvenlik düzeyini temin
              etmeye yönelik gerekli her türlü teknik ve idari tedbirlerin
              alınması sağlanarak, aşağıda yer alan amaçlar doğrultusunda
              kişisel verilerinizin üçüncü kişilerle ve kurumlarla
              paylaşılabilmesi mümkündür Bu itibarla, sigortacılık mevzuatı
              çerçevesinde Kişisel Verilerinizi paylaşabileceğimiz üçüncü
              kişiler ve paylaşım sebeplerimiz aşağıdaki gibidir:
            </p>
            <table>
              <tr>
                <th>Aktarılan Kişi/Kuruluşlar</th>
                <th>Aktarma Amaçlarımız</th>
              </tr>
              <tr valign="top">
                <td>
                  <strong
                    >&bull; İş ortaklarımızla kişisel veri paylaşımı
                    yapabiliriz.</strong
                  >
                </td>
                <td>
                  &bull; Sözleşmeden kaynaklanan edimlerin ifa edilebilmesi
                  kapsamında ticari faaliyetlerimizi yürütürken iş ortaklığı
                  kurduğumuz yetkili acenteler, reasürörler, eksperler, asistans
                  şirketleri ve aktüerler gibi taraflara kişisel verilerinizi
                  aktarabiliriz.
                </td>
              </tr>
              <tr valign="top">
                <td>
                  <strong
                    >&bull; Tedarikçilerimizle kişisel veri paylaşımı
                    yapabiliriz.</strong
                  >
                </td>
                <td>
                  &bull; Şirketimiz’in ticari faaliyetlerinin yürütülmesi
                  kapsamında, Şirketimiz’in veri işleme amaçları ve talimatları
                  doğrultusunda, Şirketimiz’e hizmet sunan taraflar ile kişisel
                  verilerinizi paylaşabiliriz.
                </td>
              </tr>
              <tr valign="top">
                <td>
                  <strong
                    >&bull; Yurt içi ve yurt dışındaki yetkili kamu kurum ve
                    kuruluşları ile kişisel veri paylaşımı yapabiliriz.</strong
                  >
                </td>
                <td>
                  &bull; Sigortacılık ve Özel Emeklilik Düzenleme ve Denetleme
                  Kurumu (SEDDK), Sigorta Bilgi ve Gözetim Merkezi (SBM) başta
                  olmak üzere yetkili kamu kurumları tarafından talep edilmesi
                  halinde, hukuki yükümlülüklerimizi yerine getirmek amacıyla
                  kişisel verilerinizi paylaşabiliriz.
                </td>
              </tr>
              <tr valign="top">
                <td>
                  <strong
                    >&bull; İştirak ve Bağlı Ortaklıklar ile kişisel veri
                    paylaşımı yapabiliriz.</strong
                  >
                </td>
                <td>
                  &bull; İştiraklerin katılımını gerektiren ticari faaliyetlerin
                  yürütülmesi amacıyla sınırlı olarak kişisel verilerin
                  aktarılabilir.
                </td>
              </tr>
              <tr valign="top">
                <td>
                  <strong
                    >&bull; Yurtdışındaki Grup Şirketleriyle kişisel veri
                    paylaşımı yapabiliriz.</strong
                  >
                </td>
                <td>
                  &bull; Kanun’a uygun olarak, İlgili Kişi’nin temel hak ve
                  özgürlüğünü zedelemeksizin özellikle Şirket’in verinin
                  paylaşılmasında meşru bir menfaati varsa veya ilgili bir
                  sözleşmenin ifasını gerektiriyorsa yurt dışındaki Grup
                  Şirketlerimize kişisel verilerinizi aktarılabiliriz.
                </td>
              </tr>
            </table>
            <p>
              Bunlarla birlikte, başta kamera kayıtları kapsamındaki kişisel
              verileriniz olmak üzere kişisel verileriniz hukuki uyuşmazlıkların
              giderilmesi veya ilgili mevzuatı gereği talep olması halinde adli
              makamlar veya ilgili kolluk kuvvetlerine aktarılabilecektir.
            </p>
            <h2 class="blue-txt">
              F- Bilgilerinizi Nasıl Kullanıyoruz, Koruyoruz ve Onaylarınızı
              Nasıl Alıyoruz?
            </h2>
            <p>
              Web sitemiz ve mobil uygulamalarımız üzerinden her türlü bilgi
              alışverişi SSL (Secure Sockets Layer) teknoloji yardımıyla
              şifrelenerek sağlanmaktadır. Bu sebeple verilen bilgiler
              internetteki diğer kişiler tarafından görülemez. Bu koruma,
              e-posta gibi yollarla gönderilen bilgiler için etkili değildir.
            </p>
            <p>
              Kullanıcılarla ilgili olarak elde ettiğimiz bilgiler, kendi ticari
              sırlarımıza gösterdiğimiz özen derecesinde gizli olarak
              korunmakta, hukuka aykırı olarak işlenmesinin veya erişilmesinin
              önlenmesi için uygun güvenlik düzeyini temin etmeye yönelik
              gerekli her türlü teknik ve idari tedbirler alınmaktadır.
            </p>
            <p>
              Kullanıcı, bu web sitesini ziyaret etmek veya mobil uygulamayı
              indirmek ve/veya kullanmak ile kişisel verilerin korunması
              hakkında mevzuat ile belirlenen ilkeler, şartlar ve usuller
              çerçevesinde olmak kaydı ile kişisel ve özel nitelikli kişisel
              verilerinin işlenmesine, yurt içine veya yurt dışına aktarılmasına
              izin vermektedir.
            </p>
            <h2 class="blue-txt">
              G- Kişisel Verisi İşlenen “İlgili Kişi” Olarak Kanun Nezdindeki
              Haklarınız Nelerdir?
            </h2>
            <p>
              6698 sayılı Kişisel Verilerin Korunması Kanunu kapsamında aşağıda
              belirtilmekte olan haklara sahipsiniz:
            </p>
            <p>
              <strong>a)</strong> Verilerinizin işlenip işlenmediğini
              öğrenebilirsiniz,
              <br />
              <strong>b)</strong> Verileriniz işlenmiş ise bilgi talep
              edebilirsiniz,
              <br />
              <strong>c)</strong> Verilerinizin işlenme amacını ve amacına uygun
              kullanılıp kullanılmadığını öğrenebilirsiniz,
              <br />
              <strong>ç)</strong> Verilerinizin yurt içinde/yurt dışında
              aktarıldığı üçüncü kişiler hakkında bilgi alabilirsiniz,
              <br />
              <strong>d)</strong> Verilerinizin eksik/yanlış işlenmiş ise,
              verilerinizin düzeltilmesini isteyebilirsiniz,
              <br />
              <strong>e)</strong> Verilerinizin silinmesini veya yok edilmesini
              (*) isteyebilirsiniz,
              <br />
              <strong>f)</strong> Yukarıda (d) ve (e) bentleri uyarınca yapılan
              işlemlerin, kişisel verilerin aktarıldığı 3ncü kişilere
              bildirilmesini isteyebilirsiniz,
              <br />
              <strong>g)</strong> Verilerinizin münhasıran otomatik sistemler
              ile analiz edilmesi nedeniyle aleyhinize bir sonucun ortaya
              çıkması durumunda bu sonuca itiraz edebilirsiniz,
              <br />
              <strong>ğ)</strong> Verilerinizin kanuna aykırı olarak işlenmesi
              sebebiyle zarara uğramanız halinde zararınızın giderilmesini talep
              edebilirsiniz,
            </p>
            <p>
              (*) Sizinle gerçekleştirmekte olduğumuz işlemlere ilişkin
              dokümanların/verilerin saklanmasına dair yasal zorunluluklarımız
              bulunmaktadır. Kişisel/Özel Nitelikli Kişisel verilerinizin
              silinmesini veya yok edilmesini talep etmeniz halinde, yasal
              zorunluluklar kapsamında belirlenen sürenin sonunda bu talebinizi
              yerine getirmemiz mümkün olabilecektir.
            </p>
            <p>
              Kişisel verileriniz hakkında daha fazla bilgi almak isterseniz,
              çağrı merkezimiz ile (0850) 250 99 99 numaradan iletişime
              geçebilir ya da
              <a href="mailto:kisiselverikoruma@axasigorta.com.tr"
                >kisiselverikoruma@axasigorta.com.tr</a
              >
              adresine elektronik posta gönderebilirsiniz.
            </p>
            <h2 class="blue-txt">H- Veri Güvenliği ve Başvuru Hakkı</h2>
            <p>
              Kişisel verileriniz teknik ve idari imkanlar dahilinde titizlikle
              korunmakta ve gerekli güvenlik tedbirleri, teknolojik imkânlar da
              göz önünde bulundurularak olası risklere uygun bir düzeyde
              sağlanmaktadır.
            </p>
            <p>
              KVKK kapsamındaki taleplerinizi, “<a
                href="https://www.axasigorta.com.tr/kisisel-veri-sahibinin-haklarini-kullanmasi-icin-basvuru"
                target="_blank"
                >https://www.axasigorta.com.tr/kisisel-veri-sahibinin-haklarini-kullanmasi-icin-basvuru</a
              >” web adresindeki “Kişisel Verilerin Korunması Kanunu Kapsamında
              Başvuru Formu” nu doldurarak;
            </p>
            <ul>
              <li>
                Meclisi Mebusan Cad. No:15 34433 Salıpazarı, Beyoğlu, İstanbul,
                TÜRKİYE adresine bizzat teslim edebilir,
              </li>
              <li>Noter kanalıyla gönderebilir,</li>
              <li>
                <a href="mailto:axasigorta@hs02.kep.tr"
                  >axasigorta@hs02.kep.tr</a
                >
                adresine güvenli elektronik ya da mobil imzalı olarak, kayıtlı
                elektronik posta adresi veya sistemimizde kayıtlı elektronik
                e-posta adresiniz aracılığıyla iletebilirsiniz.
              </li>
            </ul>
            <p>
              Bu amaçlarla yaptığınız başvurunun ek bir maliyet gerektirmesi
              durumunda, Kişisel Verileri Koruma Kurulu tarafından belirlenecek
              tarifedeki ücret tutarını ödemeniz gerekebilir. Başvurunuzda yer
              alan talepleriniz, talebin niteliğine göre en kısa sürede ve en
              geç 30 (otuz) gün içinde sonuçlandırılacaktır.
            </p>
            <p>
              * Kişisel veri envanter çalışmasında herhangi bir değişiklik
              olduğunda, Şirketimiz bu bilgilendirmeyi güncelleyecektir.
            </p>
            <p>AXA Sigorta Anonim Şirketi</p>
          </div>
        </div>

        <div v-if="store.legalNoticePopupName == 'ElektronikIletiSozlesmesi'">
          <h1>Bilgilendirme</h1>
          <div class="static-text">
            <p>
              6563 sayılı Elektronik Ticaretin Düzenlenmesi Hakkında Kanun ve
              sair mevzuat çerçevesinde AXA Sigorta A.Ş., AXA Hayat Emeklilik
              A.Ş. ve acenteleri tarafından; kısa mesaj, multimedya nesneleri
              içeren MMS, telefon, faks, elektronik posta ve benzeri iletişim
              kanallarından iletilecek; veri, ses ve görüntü içerikli
              bilgilendirme, tanıtım ve pazarlama iletilerinin tarafınıza
              gönderilmesine onay veriyorsanız lütfen kutucuğu işaretleyiniz.
            </p>
            <p>
              Dilediğiniz zaman tamamen veya ürün ve kanal bazında, veri, ses,
              görüntü ve benzeri her türlü ileti gönderimini reddetme hakkına
              sahipsiniz. İleri dönemlerde ret talebiniz olduğu takdirde lütfen
              “<strong>RET</strong>” yazıp “<strong>7292</strong>”’e kısa mesaj
              gönderiniz.
            </p>
          </div>
        </div>
        <div v-if="store.legalNoticePopupName == 'CampaignPermission'">
          <div class="static-text">
            <XInput
              type="check"
              v-model="store.sigortali.elektronikIletiOnay"
              :style="
                store.sigortali.elektronikIletiOnay ||
                store.firstElektronikIletiOnay
                  ? 'margin-bottom: 20px;'
                  : ''
              "
            >
              Tarafıma
              <a
                @click="
                  store.setLegalNoticePopupName(
                    'ElektronikIletiSozlesmesi',
                    'CampaignPermission'
                  )
                "
                >ticari elektronik ileti</a
              >
              gönderilmesine onay veriyorum.
            </XInput>
          </div>
          <ValidationError
            :message="store.validationErrorElektronikIletiSozlesmesi()"
            style="margin-bottom: 20px"
          />
          <div class="static-text">
            <p>
              <a class="button turquoise-btn" @click="store.InsertUserCampaignPermission()">Tamam</a>
            </p>
          </div>
        </div>
        <div
          v-if="store.legalNoticePopupName !== 'CampaignPermission'"
          class="static-text"
        >
          <p>
            <a
              class="button turquoise-btn"
              @click="store.setLegalNoticePopupName(store.targetPopupName)"
              >Tamam</a
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { store } from '@/store';

export default {
    data() {
        return {
            store,
        }
    },
}
</script>
